export default __webpack_public_path__ + "static/media/logo.7ae451d0.svg";